export default __webpack_public_path__ + "static/media/businessFinance.22848653.mp4";